var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0003C0 7.16359 7.16359 0 16.0003 0H32.0007C40.8374 0 48.001 7.16359 48.001 16.0003V32.0007C48.001 40.8374 40.8374 48.001 32.0007 48.001H16.0003C7.16359 48.001 0 40.8374 0 32.0007V16.0003Z",
    fill: "#DBFFF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57159 16.2867C8.57159 12.0261 12.0255 8.57227 16.286 8.57227H31.7149C35.9755 8.57227 39.4294 12.0261 39.4294 16.2867V31.7156C39.4294 35.9762 35.9755 39.43 31.7149 39.43H16.286C12.0255 39.43 8.57159 35.9762 8.57159 31.7156V16.2867Z",
    fill: "#00C773"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0006 21.8586L22.7148 26.1487L21.429 24.863",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.cf8807a0cd998332b5b7cf3d85b90357.svg";
export { ForwardRef as ReactComponent };